import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import { setBackdropLoading } from "redux/reducers/ui";

const useBackdrop = () => {
    const backdropLoading = useAppSelector((state) => state.ui.backdropLoading);

    const dispatch = useDispatch();

    const openBackdrop = () => {
        dispatch(setBackdropLoading(true));
    };

    const closeBackdrop = () => {
        dispatch(setBackdropLoading(false));
    };

    const backdrop = async (callback: Promise<any>) => {
        openBackdrop();
        await callback;
        closeBackdrop();
    };

    return {
        backdropLoading,
        backdrop,
        openBackdrop,
        closeBackdrop
    };
};

export default useBackdrop;
